var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('p',{staticClass:"font-weight-medium blue-grey--text text--darken-4 subheading",attrs:{"id":"legal"}},[_vm._v("\n    RETHYMOS Limited © "+_vm._s(new Date().getFullYear())+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }